import { environment } from '../../../../environments/environment';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { LoaderService } from '../../../shared/services/loader.service';
import { DataTableTranslations, DataTableResource, DataTable, DataTableParams, DataTablePagination } from 'angular-datatables-all-versions';
import { SubscriptionService } from '../../../shared/services/subscription.service';
import { Subscription } from '../../../shared/models/subscription.model';
import { FilterSubscriptionsComponent } from './filter-subcriptions/filter-subscriptions.component';
import { NgDataTableSortFormatterUtility } from '../../../shared/common/tools/ngdatatablesort-formatter.utility';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastyService } from 'ng2-toasty';
import * as moment from 'moment';


@Component({
  selector: 'app-subscriptions-list',
  templateUrl: './subscriptions-list.component.html',
  styleUrls: ['./subscriptions-list.component.css']
})
export class SubscriptionsListComponent implements OnInit {

  @ViewChild('dataTable', { static: false }) dataTable: DataTable;
  @ViewChild('search_input', { static: true }) searchInputRef: ElementRef;
  public site_url: string;
  public subscriptions_filtered: Subscription[] = [];
  public associations: any[];
  public subscriptions_count = 0;
  public subcriptionsResource: DataTableResource<Object>;
  public filter: string;
  public limits = [25, 50, 100];

  private subcriptions: Subscription[] = [];
  private searchParams: SearchParam;
  private routeParams: DataTableParams;
  private ngDataTableSortFormatterUtility = new NgDataTableSortFormatterUtility();

  public translations = <DataTableTranslations>{
    indexColumn: 'Num.',
    expandColumn: 'Infos.',
    selectColumn: 'Sélectionner',
    paginationLimit: 'Max.',
    paginationText: 'Résultats: {from} - {to} / {total}',
    paginationTotalPages: '/'
  }

  constructor(private route: ActivatedRoute, public router: Router, private subscriptionService: SubscriptionService,
    private loaderService: LoaderService, private toastyService: ToastyService, private modalService: NgbModal) {
    this.associations = this.route.snapshot.data['assocsForFilter'];
    this.associations.sort((a, b) => a.name.localeCompare(b.name));
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }

    this.site_url = environment.base_url;
    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        // trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = false;
        // if you need to scroll back to top, here is the right place
        window.scrollTo(0, 0);
      }
    });
  }

  ngOnInit() { }

  reload(params) {
    this.loaderService.show();
    params['simple'] = this.searchInputRef.nativeElement.value;
    if (this.searchParams) {
      params['search'] = this.searchParams;
    }
    this.routeParams = params;

      this.subscriptionService.list(params).subscribe(
        data => {
          this.subcriptions = data.charity_subscriptions;
          this.subscriptions_filtered = data.charity_subscriptions;
          this.subscriptions_count = data.meta.pagination.total_objects;

            if (params['sortAsc'] && params['sortBy'] ) {
              this.subscriptions_filtered = this.subscriptions_filtered.sort((item1, item2) => {
              const sortAsc = params['sortAsc'];
              const fieldToSort = params['sortBy'];
              let firstVal = this.ngDataTableSortFormatterUtility.resolveObjectValue(fieldToSort, item1);
              let secondVal = this.ngDataTableSortFormatterUtility.resolveObjectValue(fieldToSort, item2);

              firstVal = firstVal ? typeof firstVal === 'string' ? firstVal.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') : firstVal : '';
              secondVal = secondVal ? typeof secondVal === 'string' ? secondVal.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') : secondVal : '';

              if (fieldToSort === 'created_at' || fieldToSort === 'updated_at') {
                firstVal = new Date(firstVal);
                secondVal = new Date(secondVal);
              }

              return sortAsc ?
                firstVal < secondVal ? -1 : firstVal > secondVal ? 1 : 0
                :
                firstVal < secondVal ? 1 : firstVal > secondVal ? -1 : 0;
              });
            }
          this.loaderService.hide();
        }
      )
  }

  onSearch() {
    // this.dataTable.offset = 0;
    const search = {
      limit: this.dataTable.limit,
      offset: this.dataTable.offset,
      search: this.searchParams,
      simple: this.searchInputRef.nativeElement.value
    }
    this.reload(search);
  }

  onSearchAdvanced() {
    const modalRef = this.modalService.open(FilterSubscriptionsComponent);
    modalRef.componentInstance.assocsForFilter = this.associations;
    modalRef.result.then((result) => {
      if (result.hasOwnProperty('status')) {
        this.searchParams = Object.assign({}, {
          email: result['email'],
          status: result['status'],
          assoc: result['assoc']
        });
        // this.dataTable.offset
        const search = {
          limit: this.dataTable.limit,
          offset: this.dataTable.offset,
          search: this.searchParams,
          sortAsc: this.dataTable.sortAsc,
          sortBy: this.dataTable.sortBy,
          simple: undefined
        }
        this.reload(search);
      }
    }, err => console.log(err));
  }

  updateSubscription(id: number, type: string, newValue: number){
    const subscription = new Subscription();
    subscription.id = id;
    let message = 'Une erreur s\'est produite, rééssayez plus tard';
    if (type === 'status'){
      subscription.status = newValue;
      message = newValue === 3 ? 'Votre don mensuel a été arrêtée' : 'Votre don mensuel est de nouveau active'
    } else if (type === 'debit_day'){
      subscription.debit_day = newValue;
      message = 'Votre jour de prélèvement a été mis à jour'
    }

    this.subscriptionService.update(subscription).subscribe(
      data => {
        this.toastyService.success({
          title: 'Mise à jour',
          msg: message,
          showClose: true,
          timeout: 5000,
          theme: 'bootstrap',
        })
        if (type === 'status'){
          window.location.reload();
        }
      },
      err => this.toastyService.error({
        title: 'Attention',
        msg: 'Une erreur s\'est produite, rééssayez plus tard',
        showClose: true,
        timeout: 5000,
        theme: 'bootstrap',
      })
    );
  }

  onExportData() {
    this.routeParams.limit = this.subscriptions_count;
    const exportdata: any[] = [];

      this.subscriptionService.list(this.routeParams).subscribe(
        data => {
          const subscriptions: Subscription[] = data.charity_subscriptions;
          subscriptions.forEach((item: Subscription) => {
            let status = '';
            if (item.status === 'CANCELED'){
              status = 'Suspendue';
            } else if (item.status === 'CLOSED') {
              status = 'Terminée';
            } else if (item.status === 'ACTIVE') {
              status = 'Active';
            }

            const input = {
              'Nom': item.donated_by.name,
              'Prénom': item.donated_by.firstname,
              'Adresse e-mail': item.donated_by.email,
              'Association soutenue': item.donated_to.assoc.name,
              'Montant du don': item.amount,
              'Frais de service': item.service_fee,
              'Pourboires': item.gift_gandee,
              'Date de participation': moment(item.created_at).format('DD/MM/YYYY'),
              'Date de dernière mise à jour': moment(item.updated_at).format('DD/MM/YYYY'),
              'Statut': status,
              'URL cagnotte': 'https://www.gandee.com/participate/' + item.donated_to.id
            }

            exportdata.push(input);
          });
          this.downloadFile(exportdata);
        }
      )
  }


  private downloadFile(exportdata) {
    const csvData = this.convertToCSV(exportdata);
    const blob = new Blob([csvData], { type: 'text/csv' });
    const filename = 'export-souscriptions_' + moment().toISOString() + '.csv';
    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveBlob(blob, filename);
    } else {
      const a = window.document.createElement('a');
      a.href = window.URL.createObjectURL(blob);
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  }

  private convertToCSV(objArray) {
    const replacer = (_key, value) => value === null ? '' : value
    const header = Object.keys(objArray[0])
    let csv = objArray.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(';'))
    csv.unshift(header.join(';'));
    csv = csv.join('\r\n')
    return csv;
  }

  private getFilename(cerfa_url) {
    if (cerfa_url) {
      if (cerfa_url.url) {
        let filename = cerfa_url.url.split('/').pop();
        filename = filename.substr(0, filename.lastIndexOf('.'));
        filename = filename.replace(/_/g, '-');
        return filename;
      }
    }
  }

}

interface SearchParam {
  email: string;
  status: string;
}
